import ModalGraficos from '@core/components/ModalGraficos';
import { Grid } from '@material-ui/core';
import { getCurrency } from 'app/utils/monetarioUtil';
import moment from 'moment';
import React from 'react';
import { ContasPagarAction, useContasPagar } from '../../store';
import GraficoQuantidadeContasPagar from './GraficoQuantidadeContasPagar';
import GraficoSomatoriosContasPagar from './GraficoSomatoriosContasPagar';

const ContasPagarGraficos = () => {
  const [state, dispatch] = useContasPagar();

  const handleClose = () => {
    dispatch(ContasPagarAction.setExibirGraficos(false));
  };

  const somatoriosContasPagar = state.somatorios;

  const primeiraLetraMaiuscula = (palavra) => {
    const formatada = palavra[0].toUpperCase() + palavra.substr(1).toLowerCase();
    return formatada;
  };

  const formatarOrigemLancamento = (palavra) => {
    let palavraFormatada = '';

    if (palavra === 'CONTA_PAGAR') {
      palavraFormatada = 'Contas a pagar';
    } else if (palavra === 'COMPRA_PRODUTO') {
      palavraFormatada = 'Compras';
    }

    return palavraFormatada;
  };

  const formatarFormaPagamento = (palavra) => {
    let palavraFormatada = '';

    if (palavra === 'CARTAO_CREDITO') palavraFormatada = 'Cartão de crédito';
    if (palavra === 'CARTAO_DEBITO') palavraFormatada = 'Cartão de débito';
    if (palavra === 'CHEQUE') palavraFormatada = 'Cheque';
    if (palavra === 'DEBITO_AUTOMATICO') palavraFormatada = 'Débito automático';
    if (palavra === 'DEBITO_CONTA') palavraFormatada = 'Débito em conta';
    if (palavra === 'DOC') palavraFormatada = 'DOC';
    if (palavra === 'TED') palavraFormatada = 'TED';
    if (palavra === 'TRANSFERENCIA_BANCARIA') palavraFormatada = 'Transferência bancária';
    if (palavra === 'DINHEIRO') palavraFormatada = 'Dinheiro';
    if (palavra === 'OUTRAS') palavraFormatada = 'Outras';

    return palavraFormatada;
  };

  const getFiltroUtilizado = () => {
    const filtros = [];
    let possuiFiltroAvancado = false;

    if (state?.requestParams?.q) {
      filtros.push(`Pesquisa: ${state?.requestParams?.q}`);
    }

    if (state?.filtroAvancado?.categoria?.nome) {
      possuiFiltroAvancado = true;
      filtros.push(`Categoria: "${state.filtroAvancado.categoria?.nome}"`);
    }

    if (state?.filtroAvancado?.conta?.descricao) {
      possuiFiltroAvancado = true;
      filtros.push(`Conta: "${state.filtroAvancado.conta.descricao}"`);
    }

    if (state?.filtroAvancado?.dataEmissao) {
      possuiFiltroAvancado = true;
      filtros.push(`Data de emissão: "${state.filtroAvancado.dataEmissao.format('DD/MM/YYYY')}"`);
    }

    if (state?.filtroAvancado?.dataPagamentoInicio && state?.filtroAvancado?.dataPagamentoFim) {
      filtros.push(
        `Período de pagamento: "${state.filtroAvancado.dataPagamentoInicio.format(
          'DD/MM/YYYY'
        )}" a "${state.filtroAvancado.dataPagamentoFim.format('DD/MM/YYYY')}"`
      );
    }

    if (state?.filtroAvancado?.dataLiquidacaoInicio && state?.filtroAvancado?.dataLiquidacaoFim) {
      filtros.push(
        `Período de liquidação: "${state.filtroAvancado.dataLiquidacaoInicio.format(
          'DD/MM/YYYY'
        )}" a "${state.filtroAvancado.dataLiquidacaoFim.format('DD/MM/YYYY')}"`
      );
    }

    if (state?.filtroAvancado?.dataVencimentoInicio && state?.filtroAvancado?.dataVencimentoFim) {
      filtros.push(
        `Período de vencimento: "${state.filtroAvancado.dataVencimentoInicio.format(
          'DD/MM/YYYY'
        )}" a "${state.filtroAvancado.dataVencimentoFim.format('DD/MM/YYYY')}"`
      );
    }

    if (state?.filtroAvancado?.despesasRegulares) {
      possuiFiltroAvancado = true;
      filtros.push(`Apenas despesas regulares`);
    }

    if (state?.filtroAvancado?.documentoFiscal) {
      possuiFiltroAvancado = true;
      filtros.push(`Documento fiscal: "${state.filtroAvancado.documentoFiscal}"`);
    }

    if (state?.filtroAvancado?.formaPagamento) {
      possuiFiltroAvancado = true;
      filtros.push(`Forma de pagamento: "${formatarFormaPagamento(state.filtroAvancado.formaPagamento)}"`);
    }

    if (state?.filtroAvancado?.fornecedor?.pessoa?.nome) {
      possuiFiltroAvancado = true;
      filtros.push(`Fornecedor: "${state.filtroAvancado.fornecedor?.pessoa?.nome}"`);
    }

    if (state?.filtroAvancado?.mesCompetencia) {
      possuiFiltroAvancado = true;
      filtros.push(`Mês competência: "${state.filtroAvancado.mesCompetencia.format('MM/YYYY')}"`);
    }

    if (state?.filtroAvancado?.origemLancamento) {
      possuiFiltroAvancado = true;
      filtros.push(`Origem de lançamento: "${formatarOrigemLancamento(state.filtroAvancado.origemLancamento)}"`);
    }

    if (state?.filtroAvancado?.situacao) {
      possuiFiltroAvancado = true;
      filtros.push(`Situação: "${primeiraLetraMaiuscula(state.filtroAvancado.situacao)}"`);
    }

    if (state?.filtroAvancado?.valor) {
      possuiFiltroAvancado = true;
      filtros.push(`Valor: "${getCurrency(state.filtroAvancado.valor)}"`);
    }

    if (!possuiFiltroAvancado) {
      filtros.push(`Situação: "${primeiraLetraMaiuscula('aberta')}"`);
      filtros.push(`Mês de vencimento: "${moment().format('MM/YYYY')}"`);
    }

    return filtros.length <= 0 ? '' : `Filtros utilizados: ${filtros.join(', ')}`;
  };

  return (
    <ModalGraficos
      titulo="Indicadores do Contas a pagar"
      open={state.exibirGraficos}
      onClose={handleClose}
      nomeArquivo="Indicadores Contas pagar"
      rodape={getFiltroUtilizado()}
    >
      <div style={{ padding: 16, alignItems: 'center', justifyContent: 'center' }}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <GraficoSomatoriosContasPagar values={somatoriosContasPagar} />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <GraficoQuantidadeContasPagar values={somatoriosContasPagar} />
          </Grid>
        </Grid>
      </div>
      {/* O MVP não contempla no roadmap previsão orçamentária */}
      {/* <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
            <GraficoPrevisaoContasPagar values={somatoriosContasPagar} />
          </Grid> */}
    </ModalGraficos>
  );
};

export default ContasPagarGraficos;
